<template>
  <div class="guarantee-pop-item">
    <div class="title">
      <img v-lazy="item.serviceIcon" alt="" v-if="item.serviceIcon" />
      {{ item.serviceName }}
    </div>
    <div class="wrapper" v-if="item.serviceDesc">
      <!--下面的一层，负责展示省略号-->
      <div class="under">
        <span ref="sub" class="text" :class="{ hide: show }" v-html="format(item.serviceDesc)"></span>
        <div class="show-more fs-36" v-if="show" @click="show = false">展开</div>
        <span ref="subDesc" class="text hidden">
          我是
          <br />
          用来
          <br />
          获取
          <br />
          5行
          <br />
          高度的，适配字体大小不同动态高度！
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'text-content',
  props: {
    item: Object
  },
  data() {
    return {
      show: false,
      subHeight: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.subHeight = this.$refs.subDesc.clientHeight || 101
      if (this.$refs.sub && this.$refs.sub.clientHeight > this.subHeight) {
        this.show = true
      }
    })
  },
  methods: {
    format(val) {
      return val.replace(/\n|\r/g, '<br/>')
    }
  }
}
</script>

<style lang="scss" scoped>
.guarantee-pop-item {
  padding-bottom: 66px;

  .title {
    @include flex-start;
    font-size: 42px;
    @include fontColor($brand-text, $brand-text-dark);

    img {
      width: 54px;
      height: 54px;
      margin-right: 26px;
    }
  }

  .wrapper {
    margin-top: 27px;
    position: relative;

    .text {
      display: inline-block;
      font-size: 36px;
      color: #999999;
      line-height: 1.5;
      &.hidden {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        z-index: -1;
        visibility: hidden;
        pointer-events: none;
      }
    }

    .under {
      position: relative;

      .hide {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
      }
    }

    .show-more {
      min-width: 80px;
      line-height: 1.5;
      @include fontColor($brand-text, $brand-text-dark);
    }
  }
}
</style>
